function validCirculationDate(value) {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
  return date;
}

export function getFinancingEligibility(vehicle, now = new Date()) {
  const circulation = validCirculationDate(vehicle?.dateCirculation);
  const unavailable = { credit: false, loa: false, lld: false };
  if (!circulation || circulation > now) return unavailable;

  const cutoff = (years, months = 0) => {
    const date = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    date.setFullYear(date.getFullYear() - years);
    date.setMonth(date.getMonth() - months);
    return date;
  };

  const vatRecoverable = vehicle?.tvaRecuperable === true ||
    vehicle?.tvaRecuperable === 1 ||
    String(vehicle?.tvaRecuperable).toLowerCase() === 'oui';

  return {
    credit: circulation > cutoff(12),
    loa: vatRecoverable && circulation > cutoff(10),
    lld: vatRecoverable && circulation > cutoff(0, 24),
  };
}
